// HI UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'अपार्टमेंट और होटल',
  'site.currency': 'मुद्रा',
  'site.language': 'भाषा',
  'site.currencySelector': 'मुद्रा चयनकर्ता',
  'site.languageSelector': 'भाषा चयनकर्ता',
  'site.menu': 'मेनू',
  'site.signIn': 'साइन इन',
  'site.signOut': 'साइन आउट',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'मेनू खोलें',
  'site.footer.copyright': 'सर्वाधिकार सुरक्षित।',
  'site.footer.manageBooking': 'अपनी बुकिंग प्रबंधित करें',
  'site.footer.terms': 'नियम और शर्तें',
  'site.footer.privacy': 'गोपनीयता नीति',
  'site.trust.bestPrice': 'सर्वश्रेष्ठ मूल्य गारंटी',
  'site.trust.bestPriceDesc': 'सर्वश्रेष्ठ दरें पाएं।',
  'site.trust.flexibleBooking': 'लचीली बुकिंग',
  'site.trust.flexibleBookingDesc': 'आसान परिवर्तन और रद्दीकरण।',
  'site.trust.securePayments': 'सुरक्षित भुगतान',
  'site.trust.securePaymentsDesc': 'विश्वसनीय और सुरक्षित चेकआउट।',
  'site.trust.localSupport': 'स्थानीय सहायता',
  'site.trust.localSupportDesc': 'हम कभी भी मदद के लिए यहाँ हैं।',
  'home.heroTitle': 'अपना आदर्श ठहराव खोजें',
  'home.inAustralia': 'ऑस्ट्रेलिया में',
  'home.heroSubtitle': 'हर तरह के ठहराव के लिए अपार्टमेंट और होटल',
  'home.errorLoading': 'संपत्तियाँ लोड नहीं हो सकीं।',
  'home.noPropertiesTitle': 'अभी कोई संपत्ति उपलब्ध नहीं।',
  'home.noPropertiesDescription': 'उपलब्ध ठहराव देखने के लिए किसी गंतव्य की खोज करें।',
  'home.exploreStays': 'ठहराव देखें',
  'home.property': 'संपत्ति',
  'home.property_one': 'संपत्ति',
  'home.property_other': 'संपत्तियाँ',
  'home.properties': 'संपत्तियाँ',
  'home.foundInAustralia': 'ऑस्ट्रेलिया में मिली',
  'search.errorLoading': 'उपलब्धता लोड नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'search.noResults': 'आपके खोज मानदंड से कोई संपत्ति मेल नहीं खाती।',
  'search.mapFollow': 'जैसे ही मैं नक्शा हिलाता हूँ, खोजें',
  'search.chooseLocationTitle': 'एक स्थान चुनें',
  'search.chooseLocationDescription': 'उपलब्ध ठहराव खोजने से पहले कोई गंतव्य चुनें।',
  'search.chooseDatesTitle': 'अपनी तिथियाँ चुनें',
  'search.pastCheckIn': 'चेक-इन अतीत में नहीं हो सकता।',
  'search.checkOutAfterCheckIn': 'चेक-आउट चेक-इन के बाद होना चाहिए।',
  'search.property': 'संपत्ति',
  'search.property_one': 'संपत्ति',
  'search.property_other': 'संपत्तियाँ',
  'search.properties': 'संपत्तियाँ',
  'search.found': 'मिली',
  'widget.where': 'कहाँ',
  'widget.location': 'स्थान',
  'widget.checkInOut': 'चेक-इन / चेक-आउट',
  'widget.guests': 'मेहमान',
  'widget.rooms': 'कमरे',
  'widget.promoCode': 'प्रोमो कोड',
  'widget.promoPlaceholderCompact': 'कोड जोड़ें (वैकल्पिक)',
  'widget.promoPlaceholder': 'वैकल्पिक',
  'widget.search': 'खोजें',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'वयस्क',
  'widget.adults': 'वयस्क',
  'widget.child': 'बच्चा',
  'widget.children': 'बच्चे',
  'widget.decreaseAdults': 'वयस्क घटाएँ',
  'widget.increaseAdults': 'वयस्क बढ़ाएँ',
  'widget.decreaseChildren': 'बच्चे घटाएँ',
  'widget.increaseChildren': 'बच्चे बढ़ाएँ',
  'widget.room': 'कमरा',
  'widget.adultOption': '{count} वयस्क',
  'widget.adultOption_one': '{count} वयस्क',
  'widget.adultOption_other': '{count} वयस्क',
  'widget.childOption': '{count} बच्चे',
  'widget.childOption_one': '{count} बच्चा',
  'widget.childOption_other': '{count} बच्चे',
  'widget.roomOption': '{count} कमरे',
  'widget.roomOption_one': '{count} कमरा',
  'widget.roomOption_other': '{count} कमरे',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'स्थान लोड नहीं हो सके। कृपया पुनः प्रयास करें।',
  'widget.searchAria': 'उपलब्धता खोजें',
  'widget.dateErrorRequired': 'कृपया चेक-इन और चेक-आउट दोनों तिथियाँ चुनें।',
  'widget.dateErrorPast': 'चेक-इन अतीत में नहीं हो सकता।',
  'widget.dateErrorRange': 'चेक-आउट चेक-इन के बाद होना चाहिए।',
  'widget.dateRange.placeholder': 'चेक-इन और चेक-आउट तिथियाँ चुनें',
  'widget.dateRange.selectCheckout': 'चेक-आउट चुनें',
  'widget.dateRange.aria.checkIn': 'चेक-इन',
  'widget.dateRange.aria.checkOut': 'चेक-आउट',
  'widget.dateRange.aria.picker': 'चेक-इन / चेक-आउट तिथि सीमा चयनकर्ता',
  'widget.dateRange.previousMonth': 'पिछला महीना',
  'widget.dateRange.nextMonth': 'अगला महीना',
  'widget.dateRange.selectCheckIn': 'चेक-इन तिथि चुनें',
  'widget.dateRange.selectCheckOut': 'चेक-आउट तिथि चुनें',
  'widget.dateRange.resetToday': 'आज पर रीसेट करें',
  'widget.dateRange.done': 'हो गया',
  'property.heroAlt': 'संपत्ति हीरो',
  'property.fallbackName': '{site} द्वारा चयनित संपत्ति',
  'property.chooseRoom': 'अपना कमरा चुनें',
  'property.filterBy': 'फ़िल्टर:',
  'property.filterAll': 'सभी कमरे',
  'property.filterStudios': 'स्टूडियो',
  'property.filter1Bed': '1 बेडरूम',
  'property.filter2Bed': '2 बेडरूम',
  'property.filterApartments': 'अपार्टमेंट',
  'property.sortBy': 'क्रमबद्ध करें:',
  'property.sortRecommended': 'अनुशंसित',
  'property.sortPriceLow': 'मूल्य: कम से अधिक',
  'property.sortPriceHigh': 'मूल्य: अधिक से कम',
  'property.errorLoading': 'उपलब्धता लोड नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'property.noRooms': 'कोई कमरा उपलब्ध नहीं',
  'property.noRoomsDescription': 'भिन्न तिथियाँ या अधिवास विकल्प आज़माएँ।',
  'property.totalForNights': '{nights} रातों के लिए कुल',
  'property.perNight': 'प्रति रात',
  'property.night': 'रात',
  'property.night_one': 'रात',
  'property.night_other': 'रातें',
  'property.nights': 'रातें',
  'property.freeCancellation': 'मुफ़्त रद्दीकरण',
  'property.selectRoom': 'कमरा चुनें',
  'property.selected': 'चयनित',
  'property.continue': 'जारी रखें',
  'property.previousPhoto': 'पिछली तस्वीर',
  'property.nextPhoto': 'अगली तस्वीर',
  'property.addToWishlist': 'इच्छा सूची में जोड़ें',
  'property.popularChoice': 'लोकप्रिय विकल्प',
  'property.showMore': 'और देखें',
  'property.showLess': 'कम देखें',
  'property.maxOccupancy': 'अधिकतम अधिवास:',
  'property.size': 'आकार:',
  'property.bedType': 'बिस्तर का प्रकार:',
  'property.roomAmenities': 'कमरे की सुविधाएँ',
  'property.showMoreAmenities': '+{count} और',
  'property.guests': 'मेहमान',
  'property.adults': 'वयस्क',
  'property.children': 'बच्चे',
  'property.onlyRoomsLeft': 'केवल {count} कमरे शेष हैं',
  'property.onlyRoomsLeft_one': 'केवल {count} कमरा शेष है',
  'property.onlyRoomsLeft_other': 'केवल {count} कमरे शेष हैं',
  'property.lastBookedMinutes': 'अंतिम बुकिंग {count} मिनट पहले',
  'property.lastBookedMinutes_one': 'अंतिम बुकिंग {count} मिनट पहले',
  'property.lastBookedMinutes_other': 'अंतिम बुकिंग {count} मिनट पहले',
  'property.lastBookedHours': 'अंतिम बुकिंग {count} घंटे पहले',
  'property.lastBookedHours_one': 'अंतिम बुकिंग {count} घंटा पहले',
  'property.lastBookedHours_other': 'अंतिम बुकिंग {count} घंटे पहले',
  'property.lastBookedDays': 'अंतिम बुकिंग {count} दिन पहले',
  'property.lastBookedDays_one': 'अंतिम बुकिंग {count} दिन पहले',
  'property.lastBookedDays_other': 'अंतिम बुकिंग {count} दिन पहले',
  'property.checkInTime': 'चेक-इन {time}',
  'property.checkOutTime': 'चेक-आउट {time}',
  'property.compare': 'तुलना करें',
  'property.taxesIncluded': 'कर और शुल्क सहित प्रति रात',
  'property.chooseRate': 'अपनी दर चुनें',
  'property.yourSelection': 'आपका चयन',
  'property.aboutRoom': 'इस कमरे के बारे में',
  'property.roomDetails': 'कमरे का विवरण',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'कमरों पर वापस',
  'property.standardRate': 'मानक दर',
  'property.noPromotion': 'इस दर के लिए कोई प्रचालन उपलब्ध नहीं।',
  'property.youSave': 'आप ({percent}% की बचत) - {amount} बचाते हैं',
  'property.inclusions': 'समावेश:',
  'property.viewAllPhotos': 'सभी तस्वीरें देखें',
  'property.seeOnMap': 'नक्शे पर देखें',
  'room.perNight': 'रात',
  'room.sleeps': 'सो सकते हैं',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'उपलब्ध',
  'room.select': 'चुनें',
  'room.selected': 'चयनित',
  'card.viewAvailability': 'उपलब्धता देखें',
  'card.from': 'से',
  'card.night': 'रात',
  'card.checkAvailability': 'उपलब्धता जाँचें',
  'card.saveToFavourites': 'पसंदीदा में सहेजें',
  'card.ratingExcellent': 'उत्कृष्ट',
  'card.ratingVeryGood': 'बहुत अच्छा',
  'card.ratingGood': 'अच्छा',
  'card.ratingGuest': 'मेहमान रेटिंग',
  'guest.stepChooseRoom': 'कमरा चुनें',
  'guest.stepGuestDetails': 'मेहमान विवरण',
  'guest.stepPayment': 'भुगतान',
  'guest.stepConfirmation': 'पुष्टि',
  'guest.title': 'मेहमान विवरण दर्ज करें',
  'guest.subtitle': 'कृपया अपनी जानकारी दें।',
  'guest.firstName': 'पहला नाम',
  'guest.lastName': 'उपनाम',
  'guest.email': 'ईमेल',
  'guest.emailHint': 'बुकिंग पुष्टिकरण इस ईमेल पर भेजा जाएगा।',
  'guest.country': 'देश',
  'guest.selectCountry': 'देश चुनें',
  'guest.searchCountry': 'देश खोजें…',
  'guest.loadingCountries': 'देश लोड हो रहे हैं…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'पिन कोड',
  'guest.phone': 'फ़ोन नंबर',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'फ़ोन नंबर दर्ज करें',
  'guest.address': 'पता',
  'guest.city': 'शहर',
  'guest.specialRequests': 'विशेष अनुरोध (वैकल्पिक)',
  'guest.specialRequestsPlaceholder': 'कोई विशेष अनुरोध?',
  'guest.termsPrefix': 'इस बुकिंग को पूरा करके, मैं सहमत हूँ ',
  'guest.terms': 'नियम और शर्तें',
  'guest.termsAnd': 'और',
  'guest.privacy': 'गोपनीयता नीति',
  'guest.termsSuffix': ', और मैं बुकिंग की शर्तें स्वीकार करता हूँ।',
  'guest.marketingOptOut': 'मैं मार्केटिंग संदेश प्राप्त नहीं करना चाहता।',
  'guest.cardVerify':
    'एक अस्थायी 1 {currency} कार्ड सत्यापन रखा जाएगा। अभी आपसे शुल्क नहीं लिया जाएगा।',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'भुगतान संपत्ति पर लिया जाएगा।',
  'guest.noRoomsSelected': 'कोई कमरा चयनित नहीं।',
  'guest.noPropertySelected': 'कोई संपत्ति चयनित नहीं।',
  'guest.paymentStillLoading':
    'भुगतान विकल्प अभी लोड हो रहे हैं। कृपया कुछ क्षण बाद पुनः प्रयास करें।',
  'guest.submitProcessing': 'प्रोसेस हो रहा है…',
  'guest.submitVerifyCard': 'कार्ड सत्यापित करें और बुकिंग की पुष्टि करें',
  'guest.submitConfirm': 'बुकिंग की पुष्टि करें',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'भुगतान',
  'payment.method': 'भुगतान का तरीका',
  'payment.cardDetailsHint':
    'अपने कार्ड विवरण को सुरक्षित रूप से नीचे दर्ज करें। आपके कार्ड विवरण टोकनाइज़ होते हैं और कभी हमारे सर्वर तक नहीं पहुँचते।',
  'payment.loadingForm': 'भुगतान फ़ॉर्म लोड हो रहा है…',
  'payment.formUnavailable': 'भुगतान फ़ॉर्म उपलब्ध नहीं।',
  'payment.acceptTerms': 'मैं नियम और शर्तें और रद्दीकरण नीति स्वीकार करता हूँ।',
  'payment.payNow': 'अब भुगतान करें',
  'payment.processing': 'प्रोसेस हो रहा है…',
  'payment.noRoomsSelected': 'कोई कमरा चयनित नहीं।',
  'payment.redirecting': 'सुरक्षित भुगतान पृष्ठ पर पुनर्निर्देशित किया जा रहा है…',
  'payment.notConfigured': 'इस संपत्ति के लिए Quickstream कॉन्फ़िगर नहीं है।',
  'payment.noScript': 'Quickstream भुगतान सेवा लोड नहीं हो सकी। कृपया पृष्ठ रीफ़्रेश करें।',
  'payment.formNotLoaded': 'भुगतान फ़ॉर्म लोड नहीं हुआ। कृपया पृष्ठ रीफ़्रेश करें।',
  'payment.cardDetails': 'भुगतान विफल। कृपया अपने कार्ड विवरण जाँचें।',
  'payment.tokenizationFailed': 'कार्ड टोकनाइज़ेशन विफल। कृपया पुनः प्रयास करें।',
  'payment.failed': 'भुगतान विफल।',
  'payment.statusResult': 'भुगतान स्थिति: {status}। कृपया पुनः प्रयास करें।',
  'confirmation.loading': 'आपकी बुकिंग लोड हो रही है…',
  'confirmation.notFound': 'बुकिंग नहीं मिली। अपना बुकिंग संदर्भ जाँचें और पुनः प्रयास करें।',
  'confirmation.errorGeneric': 'आपकी बुकिंग की पुष्टि नहीं हो सकी। कृपया सहायता से संपर्क करें।',
  'confirmation.errorLoadDetails': 'आरक्षण विवरण लोड नहीं हो सका।',
  'confirmation.couldNotComplete': 'हम आपका भुगतान पूरा नहीं कर सके',
  'confirmation.startNew': 'नई बुकिंग शुरू करें',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'भुगतान सत्र नहीं मिला। कृपया सहायता से संपर्क करें।',
  'confirmation.paymentStateInvalid':
    'भुगतान पूरा करने के लिए वैध स्थिति में नहीं है। कृपया फिर से शुरू करें।',
  'confirmation.paymentFailedDeclined':
    'आपका भुगतान पूरा नहीं हो सका। कृपया अपने कार्ड विवरण जाँचें और पुनः प्रयास करें, या कोई अन्य भुगतान विधि का उपयोग करें।',
  'confirmation.paymentTimeout': 'भुगतान में बहुत अधिक समय लगा। कृपया पुनः प्रयास करें।',
  'confirmation.paymentGatewayUnavailable':
    'भुगतान प्रणाली अस्थायी रूप से उपलब्ध नहीं है। कृपया कुछ क्षणों में पुनः प्रयास करें।',
  'confirmation.paymentUnknown': 'भुगतान की पुष्टि नहीं हो सकी: {message}।',
  'confirmation.paymentGenericError':
    'भुगतान की पुष्टि नहीं हो सकी। कृपया पुनः प्रयास करें या सहायता से संपर्क करें।',
  'summary.title': 'आपकी बुकिंग सारांश',
  'summary.yourBooking': 'आपकी बुकिंग सारांश',
  'summary.noRoomsSelected': 'अभी तक कोई कमरा चयनित नहीं।',
  'summary.checkIn': 'चेक-इन',
  'summary.checkOut': 'चेक-आउट',
  'summary.lengthOfStay': 'ठहराव की अवधि',
  'summary.guests': 'मेहमान',
  'summary.nights': '{nights} रातें',
  'summary.nights_one': '{nights} रात',
  'summary.nights_other': '{nights} रातें',
  'summary.totalForNights': '{nights} रातों के लिए कुल',
  'summary.includingTaxes': 'कर और शुल्क सहित',
  'summary.discount': '{amount} बचाएँ',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'बुकिंग की पुष्टि हो गई!',
  'detail.received': 'बुकिंग प्राप्त हुई',
  'detail.referenceIntro': 'आपका बुकिंग संदर्भ है',
  'detail.reservationId': 'आरक्षण आईडी:',
  'detail.processing':
    'आपकी बुकिंग प्रोसेस हो रही है। भुगतान की पुष्टि होने पर आपको पुष्टिकरण ईमेल प्राप्त होगा।',
  'detail.guest': 'मेहमान',
  'detail.rooms': 'कमरे',
  'detail.night': 'रात',
  'detail.nights': 'रातें',
  'detail.adult': 'वयस्क',
  'detail.adults': 'वयस्क',
  'detail.child': 'बच्चा',
  'detail.infant': 'शिशु',
  'detail.priceBreakdown': 'मूल्य विवरण',
  'detail.subtotal': 'उप-कुल',
  'detail.taxes': 'कर',
  'detail.fees': 'शुल्क',
  'detail.discounts': 'छूट',
  'detail.surcharge': 'कार्ड अधिभार',
  'detail.grandTotal': 'कुल योग',
  'priceBreakdown.roomSubtotal': 'कमरे का उप-कुल',
  'priceBreakdown.total': 'कुल',
  'detail.deposit': 'जमा राशि',
  'detail.depositDueBy': 'तक देय',
  'detail.arrival': 'आगमन',
  'detail.specialRequests': 'विशेष अनुरोध',
  'detail.backToHome': 'होम पर वापस',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'पुनः प्रयास करें',
  'shared.close': 'बंद करें',
  'shared.back': 'वापस',
  'shared.previous': 'पिछला',
  'shared.next': 'अगला',
  'validation.firstNameRequired': 'पहला नाम आवश्यक है',
  'validation.lastNameRequired': 'उपनाम आवश्यक है',
  'validation.emailRequired': 'वैध ईमेल आवश्यक है',
  'validation.phoneRequired': 'फ़ोन नंबर आवश्यक है',
  'validation.addressRequired': 'पता आवश्यक है',
  'validation.cityRequired': 'शहर आवश्यक है',
  'validation.countryRequired': 'देश आवश्यक है',
  'validation.postalCodeRequired': 'पिन कोड आवश्यक है',
  'error.pmsUnavailable':
    'क्षमा करें, यह कमरा आपकी चयनित दिनांकों के लिए अब उपलब्ध नहीं है। कृपया वापस जाएँ और भिन्न तिथियाँ या कोई अन्य कमरा चुनें।',
  'error.pmsSyncError':
    'हम संपत्ति प्रणाली से कनेक्ट नहीं हो सके। कृपया कुछ क्षणों में पुनः प्रयास करें।',
  'error.paymentNotConfigured':
    'इस संपत्ति के लिए भुगतान कॉनफ़िगर नहीं है। कृपया कोई अन्य संपत्ति चुनें या सहायता से संपर्क करें।',
  'error.paymentStartFailed': 'भुगतान शुरू करते समय कुछ गड़बड़ी हुई। कृपया पुनः प्रयास करें।',
  'error.bookingFailed': 'बुकिंग विफल। कृपया पुनः प्रयास करें।',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'अपना ठहराव बुक करें',
  'site.title.suffix': 'अपार्टमेंट और होटल',
  'site.title.home': 'होम',
  'site.title.search': 'खोज',
  'site.title.property': 'संपत्ति',
  'site.title.room': 'कमरा',
  'site.title.guestDetails': 'मेहमान विवरण',
  'site.title.payment': 'भुगतान',
  'site.title.confirmation': 'बुकिंग की पुष्टि',
  'site.title.bookingLookup': 'अपनी बुकिंग खोजें',
  'site.title.bookingDetails': 'बुकिंग विवरण',
  'site.title.cancellation': 'बुकिंग रद्द करें',
  'site.title.reservationDetail': 'आरक्षण विवरण',
  'site.title.signIn': 'साइन इन',
  'site.title.signUp': 'साइन अप',
  'site.title.notFound': 'पृष्ठ नहीं मिला',
  'notFound.title': 'पृष्ठ नहीं मिला',
  'notFound.message': 'आप जिस पृष्ठ को खोज रहे हैं, वह मौजूद नहीं है।',
  'notFound.backHome': 'होम पर वापस',
  'home.heroAlt': 'ऑस्ट्रेलियन शहर की स्काइलाइन',
  'home.featuredProperties': 'विशेष संपत्तियाँ',
  'home.popularDestinations': 'लोकप्रिय गंतव्य',
  'common.reviews': '{count} समीक्षाएँ',
  'common.reviews_one': '{count} समीक्षा',
  'common.reviews_other': '{count} समीक्षाएँ',
  'common.loading': 'लोड हो रहा है',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'का',
  'common.select': 'चुनें…',
  'common.search': 'खोजें…',
  'common.selectLocation': 'एक स्थान चुनें',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'कोई विकल्प उपलब्ध नहीं',
  'common.code': 'कोड',
  'common.searchCode': 'कोड खोजें…',
  'filter.title': 'फ़िल्टर',
  'filter.price': 'मूल्य',
  'filter.priceMinimum': 'न्यूनतम',
  'filter.priceMaximum': 'अधिकतम',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'संपत्ति का प्रकार',
  'filter.propertyType.hotel': 'होटल',
  'filter.propertyType.apartment': 'अपार्टमेंट',
  'filter.propertyType.resort': 'रिसॉर्ट',
  'filter.amenities': 'सुविधाएँ',
  'filter.amenity.pool': 'पूल',
  'filter.amenity.parking': 'पार्किंग',
  'filter.amenity.breakfast': 'नाश्ता शामिल',
  'filter.rating': 'रेटिंग',
  'filter.rating.any': 'कोई भी रेटिंग',
  'filter.rating.5': '5 सितारे',
  'filter.rating.4': '4 सितारे और उससे अधिक',
  'filter.rating.3': '3 सितारे और उससे अधिक',
  'filter.more': 'और',
  'filter.more.freeCancellation': 'मुफ़्त रद्दीकरण',
  'filter.more.payAtProperty': 'संपत्ति पर भुगतान करें',
  'filter.clear': 'साफ़ करें',
  'filter.apply': 'फ़िल्टर लागू करें',
  'card.reviews_one': 'समीक्षा',
  'card.reviews_other': 'समीक्षाएँ',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'आयु 0 - 12',
  'auth.orContinueWith': 'या इसके साथ जारी रखें',
  'auth.signIn.title': 'अपने खाते में साइन इन करें',
  'auth.signIn.subtitle':
    'वापसी पर स्वागत है! अपनी बुकिंग प्रबंधित करने, अपने ठहराव देखने और विशेष ऑफ़र पाने के लिए साइन इन करें।',
  'auth.email': 'ईमेल',
  'auth.emailPlaceholder': 'अपना ईमेल पता दर्ज करें',
  'auth.emailRequired': 'ईमेल आवश्यक है।',
  'auth.emailInvalid': 'कृपया एक वैध ईमेल पता दर्ज करें।',
  'auth.password': 'पासवर्ड',
  'auth.passwordPlaceholder': 'अपना पासवर्ड दर्ज करें',
  'auth.createPasswordPlaceholder': 'पासवर्ड बनाएँ',
  'auth.passwordRequired': 'पासवर्ड आवश्यक है।',
  'auth.passwordMinLength': 'पासवर्ड कम से कम {min} अक्षरों का होना चाहिए।',
  'auth.passwordPattern': 'पासवर्ड में अक्षर और अंक दोनों होने चाहिए।',
  'auth.passwordHint':
    'कम से कम {min} अक्षरों वाला पासवर्ड उपयोग करें जिसमें अक्षर, अंक और प्रतीक मिले हों।',
  'auth.showPassword': 'पासवर्ड दिखाएँ',
  'auth.hidePassword': 'पासवर्ड छुपाएँ',
  'auth.keepSignedIn': 'मुझे साइन इन रखें',
  'auth.forgotPassword': 'पासवर्ड भूल गए?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'साइन इन',
  'auth.signingIn': 'साइन इन हो रहा है...',
  'auth.signInError': 'साइन इन विफल। कृपया पुनः प्रयास करें।',
  'auth.googleError': 'Google साइन-इन विफल।',
  'auth.noAccount': 'खाता नहीं है?',
  'auth.createAccount': 'खाता बनाएँ',
  'auth.signUp.title': 'अपना खाता बनाएँ',
  'auth.signUp.subtitle':
    'अपनी बुकिंग प्रबंधित करने, पसंदीदा संपत्तियाँ सहेजने और विशेष ऑफ़र पाने के लिए {site} से जुड़ें।',
  'auth.firstName': 'पहला नाम',
  'auth.firstNamePlaceholder': 'अपना पहला नाम दर्ज करें',
  'auth.firstNameRequired': 'पहला नाम आवश्यक है।',
  'auth.lastName': 'उपनाम',
  'auth.lastNamePlaceholder': 'अपना उपनाम दर्ज करें',
  'auth.lastNameRequired': 'उपनाम आवश्यक है।',
  'auth.mobile': 'मोबाइल नंबर',
  'auth.mobilePlaceholder': 'अपना मोबाइल नंबर दर्ज करें',
  'auth.dialingCode': 'देश डायलिंग कोड',
  'auth.mobileRequired': 'मोबाइल नंबर आवश्यक है।',
  'auth.mobileInvalid': 'कृपया एक वैध मोबाइल नंबर दर्ज करें।',
  'auth.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'auth.confirmPasswordPlaceholder': 'अपना पासवर्ड पुष्टि करें',
  'auth.termsAgree': 'मैं सहमत हूँ',
  'auth.termsRequired': 'आपको नियम और शर्तें और गोपनीयता नीति से सहमत होना चाहिए।',
  'auth.marketingConsent':
    'मैं {site} से विशेष ऑफ़र और यात्रा प्रेरणा प्राप्त करना चाहता/चाहती हूँ',
  'auth.signUpError': 'खाता नहीं बन सका। कृपया पुनः प्रयास करें।',
  'auth.signUp': 'साइन अप',
  'auth.creatingAccount': 'खाता बन रहा है...',
  'auth.createAccountButton': 'खाता बनाएँ',
  'auth.alreadyHaveAccount': 'पहले से ही खाता है?',
  'auth.passwordMismatch': 'पासवर्ड मेल नहीं खाते।',
  'pricing.title': 'मूल्य सारांश',
  'pricing.noRoomsSelected': 'कोई कमरा चयनित नहीं। कृपया वापस जाएँ और कमरे चुनें।',
  'pricing.backToAvailability': 'उपलब्धता पर वापस',
  'pricing.continue': 'मेहमान विवरण पर जारी रखें',
  'property.youSavePercent': 'आप ({percent}% की बचत) बचाते हैं',
  'property.includingTaxesFees': '(कर और शुल्क सहित)',
  'map.zoomIn': 'ज़ूम इन',
  'map.zoomOut': 'ज़ूम आउट',
  'map.viewFullMap': 'पूर्ण नक्शे में देखें',
  'booking.progress': 'बुकिंग प्रगति',
  'reservationDetail.resetAria': 'बुकिंग स्थिति रीसेट करें',
  'bookingLookup.title': 'अपनी बुकिंग खोजें',
  'bookingLookup.description':
    'अपना आरक्षण देखने, संशोधित करने या रद्द करने के लिए अपना बुकिंग संदर्भ और ईमेल दर्ज करें।',
  'bookingLookup.bookingReference': 'बुकिंग संदर्भ',
  'bookingLookup.placeholder': 'उदा. SYD-260815-0001',
  'bookingLookup.lookingUp': 'खोज जा रही है…',
  'bookingLookup.findBooking': 'बुकिंग खोजें',
  'bookingLookup.notFound':
    'बुकिंग नहीं मिली। BK-2026-001, alex.morgan@example.com और Morgan आज़माएँ।',
  'cancellation.title': 'बुकिंग रद्द करें',
  'cancellation.property': 'संपत्ति',
  'cancellation.details': 'रद्दीकरण विवरण',
  'cancellation.penalty': 'रद्दीकरण शुल्क',
  'cancellation.refund': 'धनवापसी राशि',
  'cancellation.totalPaid': 'कुल भुगतान:',
  'cancellation.reasonLabel': 'रद्दीकरण का कारण (वैकल्पिक)',
  'cancellation.understand': 'मुझे पता है कि इस क्रिया को वापस नहीं किया जा सकता।',
  'cancellation.cancelledDemo':
    'आपकी बुकिंग इस UI डेमो में रद्द कर दी गई है। धनवापसी राशि: {{refundAmount}}।',
  'cancellation.confirm': 'रद्दीकरण की पुष्टि करें',
  'cancellation.notFound': 'बुकिंग नहीं मिली।',
  'bookingDetails.title': 'बुकिंग विवरण',
  'bookingDetails.notFound': 'बुकिंग नहीं मिली।',
  'bookingDetails.checkIn': 'चेक-इन:',
  'bookingDetails.checkOut': 'चेक-आउट:',
  'bookingDetails.rooms': 'कमरे',
  'bookingDetails.guest': 'मेहमान',
  'bookingDetails.freeCancellationUntil': '{date} तक मुफ़्त रद्दीकरण',
  'bookingDetails.total': 'कुल:',
  'reservationDetail.loading': 'आपकी बुकिंग लोड हो रही है…',
  'reservationDetail.noReference': 'कोई बुकिंग संदर्भ प्रदान नहीं किया गया।',
  'reservationDetail.loadError': 'आरक्षण विवरण लोड नहीं हो सका।',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'स्थान लोड हो रहे हैं…',
  'common.couldNotLoadLocations': 'स्थान लोड नहीं हो सके',
  'common.searchLocationPlaceholder': 'देश, शहर या संपत्ति खोजें',
  'common.collapse': 'संकुचित करें',
  'common.expand': 'विस्तार करें',
  'map.loadingGoogle': 'Google Map लोड हो रहा है…',
  'map.errorGoogle': 'Google Maps लोड नहीं हो सका',
  'map.errorMap': 'नक्शा लोड नहीं हो सका।',
  'map.greatLocation': 'बढ़िया स्थान',
  'home.trust.secureBooking': 'सुरक्षित बुकिंग',
  'home.trust.secureBookingDesc': 'आपकी जानकारी हमारे साथ सुरक्षित है।',
  'home.trust.bestPrice': 'सर्वश्रेष्ठ मूल्य गारंटी',
  'home.trust.bestPriceDesc': 'कम दाम मिला? हम उसे मैच करेंगे।',
  'home.trust.localSupport': '24/7 सहायता',
  'home.trust.localSupportDesc': 'हम कभी भी मदद के लिए यहाँ हैं।',
  'home.trust.flexibleBooking': 'लचीले विकल्प',
  'home.trust.flexibleBookingDesc': 'चयनित दरों पर मुफ़्त रद्दीकरण।',
  'promotion.memberPromo': 'सदस्य प्रोमो',
  'promotion.save': 'बचाएँ',
  'property.memberRate': 'सदस्य दर',
  'property.hideAmenities': 'सुविधाएँ छुपाएँ',
  'property.showAllAmenities': 'सभी सुविधाएँ दिखाएँ',
  'property.chooseRatePromo': 'अपनी पसंदीदा दर चुनें - सदस्य दरें विशेष बचत प्रदान करती हैं!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% छूट',
  'gallery.imageAlt': '{title} दृश्य {current} में से {total}',
  'gallery.thumbnailAlt': 'दृश्य {current} में से {total} पर जाएँ',
  'gallery.previewAlt': '{title} पूर्वावलोकन',
  'detail.night_one': 'रात',
  'detail.night_other': 'रातें',
  'detail.adult_one': 'वयस्क',
  'detail.adult_other': 'वयस्क',
  'detail.child_one': 'बच्चा',
  'detail.child_other': 'बच्चे',
  'detail.infant_one': 'शिशु',
  'detail.infant_other': 'शिशु',
} as const;
